
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11626',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11626",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.449",
  "dashboard-client-types": "static-1.247",
  "data-fetching-client": "static-1.9502",
  "foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.8",
  "foundations-components-legacy": "static-1-jhardy-popover-allow-cross-axis-shift.8",
  "foundations-theming": "static-1.4238",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7832",
  "hub-http-shared-msw-handlers": "static-1.9529",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11259",
  "I18n": "static-7.1577",
  "jasmine-runner": "static-1.6297",
  "marketplace-storefront-base": "static-1.11686",
  "quartz": "static-1.6768",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16477",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2688",
  "reporting-testing-lib": "static-1.8553",
  "settings-ui-lib": "static-1.12348",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6779",
  "ui-addon-i18n": "static-1.10969",
  "ui-addon-react-router-dom": "static-1.9371",
  "unified-auth": "static-1.248",
  "unified-auth-core-lib": "static-1.529",
  "usage-tracker": "static-1.7161",
  "usage-tracker-core": "static-1.7011",
  "customer-data-property-utils": "static-1.7905",
  "history": "static-4.47",
  "hub-http": "static-1.6045",
  "integrations-lib": "static-1.15495",
  "marketplace-ui-common": "static-1.19012",
  "property-management-iframe": "static-1.12425",
  "quartz-config": "static-1.546",
  "quartz-core": "static-1.5987",
  "quartz-routing": "static-1.198",
  "quick-fetch": "static-1.3761",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4460",
  "ts-schema": "static-1.3929",
  "ui-universal-auth": "static-1.8734",
  "UIComponents": "static-3.8206",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3253",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3045",
  "quartz-webpack": "static-1.2992",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.8",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4662",
  "foundations-theming-specialty": "static-1.1954",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9252",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5199",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1287",
  "ui-fonts": "static-1.521",
  "ui-images": "static-2.1101",
  "bend-plugin-foundations-theming": "static-1.2721",
  "foundations-theming-base": "static-1.3223",
  "stylex": "static-1.28",
  "HeadJS": "static-2.715",
  "hs-test-utils-bend-plugin": "static-1.2943",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4152",
  "ai-components-ui-library": "static-1.8413",
  "ai-rendering-library": "static-1.9371",
  "chirp-fetch": "static-1.1708",
  "connections-embed-lib": "static-1.671",
  "copilot-toolkit": "static-1.10593",
  "laboratory-lib": "static-3.6985",
  "marketplace-embed": "static-1.21534",
  "marketplace-ui-details": "static-1.8908",
  "marketplace-ui-reviews": "static-1.18968",
  "marketplace-ui-tracking": "static-1.13183",
  "sanitize-text": "static-1.7970",
  "ui-addon-video-player": "static-1.8522",
  "usage-tracker-multi": "static-1.5575",
  "usage-tracker-session-replay": "static-1.4847",
  "wootric-nps": "static-1.6810",
  "apollo-link-hub-http": "static-2.4477",
  "immer": "static-1.33",
  "immerable": "static-1.3980",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66620",
  "cssUtils": "static-1.741",
  "flux-actions": "static-1.310",
  "HubStyle": "static-2.11567",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10036",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10198",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7151",
  "icons": "static-2.623",
  "marketplace-ui-apps-core": "static-1.17545",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4346",
  "foundations-components-test-utils": "static-1-jhardy-popover-allow-cross-axis-shift.8",
  "quartz-i18n": "static-1.443",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3557",
  "customer-data-objects": "static-1.7474",
  "property-translator": "static-1.5236",
  "frontend-preferences-client": "static-1.7750",
  "hs-promise-utils": "static-1.5419",
  "hubspot-apollo-client": "static-1.4706",
  "integrations-error-boundary-lib": "static-1.12910",
  "integrations-tracking-lib": "static-1.5414",
  "native-integrations-shared-strings": "static-1.7614",
  "reselect": "static-2.16",
  "sanitize": "static-1.4300",
  "superstore": "static-1.4596",
  "ui-shepherd-react": "static-3.9972",
  "ai-settings-ui-library": "static-1.7535",
  "hub-http-janus": "static-1.800",
  "hubspotter-http": "static-1.4502",
  "immutable-less": "static-1.4480",
  "marketplace-ui-client-types": "static-1.16419",
  "nav-meta": "static-1.28982",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10065",
  "ui-addon-upgrades": "static-9.17693",
  "inbound-db-properties-service-client": "static-1.3699",
  "property-management-common": "static-1.4712",
  "ui-addon-iframeable": "static-1.8872",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.488",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.443",
  "quartz-head": "static-1.433",
  "quartz-test": "static-1.443",
  "quartz-tracking": "static-1.147",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2970",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20426",
  "ContentUtils": "static-1.67688",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2314",
  "customer-data-filters-ui": "static-1.38983",
  "customer-data-objects-ui-components": "static-1.12834",
  "customer-data-reference-ui-components": "static-1.12972",
  "embedded-academy-lib": "static-1.13625",
  "ExportDialog": "static-6.10212",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40714",
  "reporting-snowflake": "static-1.55238",
  "reporting-ui-components": "static-2.63891",
  "reporting-visualizations": "static-1.58696",
  "ui-addon-teams": "static-1.21274",
  "magpie-lib": "static-1.5420",
  "magpie-types": "static-1.4880",
  "simple-logging-lib": "static-1.2876",
  "navigation-components": "static-1.17345",
  "ai-studio-lib": "static-1.11060",
  "developer-experience-shared-components": "static-1.10316",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7816",
  "ui-tool-access": "static-1.9971",
  "usage-based-billing-components-lib": "static-1.8071",
  "usage-tracker-anonymous": "static-1.5578",
  "usage-tracker-public": "static-1.6972",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3445",
  "persist-promise": "static-1.3533",
  "reference-resolvers": "static-1.7987",
  "ui-extensibility-client-types": "static-1.3769",
  "hubspot-apollo-cache": "static-1.165",
  "universal-page-editor-lib": "static-1.2825",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2245",
  "merchandise-lib": "static-1.260",
  "atom": "static-1.4895",
  "purchase-motions-components": "static-1.5515",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1376",
  "crm-component-utils": "static-1.38528",
  "crm-properties-common-lib": "static-1.5697",
  "framework-data-schema-resolvers": "static-1.6698",
  "reference-resolvers-lite": "static-1.7920",
  "navigation-messaging": "static-1.6672",
  "hubspotter-http-shared-msw-handlers": "static-1.9527",
  "cms-field-types": "static-1.4632",
  "content-icons-ui": "static-1.2164",
  "conversations-skeleton-state": "static-1.7074",
  "crm-message-bus": "static-1.42429",
  "customer-data-filters-ui-msw-helpers": "static-1.21418",
  "customer-data-ui-utilities": "static-1.9649",
  "FormUrlGenerator": "static-2.4553",
  "framework-builder-read-service-client": "static-1.3858",
  "framework-data-schema-quick-fetch": "static-1.6603",
  "multi-account-reference-resolvers": "static-1.799",
  "onboarding-tours": "static-1.16300",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13124",
  "academy-common-lib": "static-1.13085",
  "content-assistance-lib": "static-1.7485",
  "dashboard-lib": "static-1.80718",
  "file-manager-components": "static-1.22970",
  "getting-started-shared-tasks": "static-1.17946",
  "hubspot-prosemirror": "static-1.17665",
  "hubspot-prosemirror-plugins": "static-1.17657",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19514",
  "share-with-third-party-component-lib": "static-1.8519",
  "ui-addon-draggable": "static-3.4591",
  "ui-asset-management-lib": "static-1.10742",
  "ui-business-units-lib": "static-1.8855",
  "user-context": "static-1.4925",
  "growth-payments-core": "static-1.24788",
  "reporting-plugins": "static-1.10017",
  "reporting-reports": "static-1.66298",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.550",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28905",
  "react-codemirror": "static-1.10452",
  "apps-service-types": "static-1.3703",
  "oauth-service-types": "static-1.4072",
  "onboarding-scopes": "static-1.6288",
  "onboarding-tours-client": "static-1.4514",
  "platform-infra-nav-components": "static-1.7516",
  "subscription-experience-data-types": "static-1.14614",
  "crm-record-cards-service-types": "static-1.3468",
  "location-customization-utils-lib": "static-1.8631",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2183",
  "purchase-motions-api": "static-1.5518",
  "signup-constants": "static-1.18469",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3730",
  "card-properties-lib": "static-1.43586",
  "commerce-subscription-lib": "static-1.36504",
  "crm-actions": "static-1.6131",
  "crm-cards-data": "static-1.1261",
  "crm-cards-sdk": "static-1.42986",
  "customer-data-properties": "static-1.50858",
  "customer-data-properties-shared-msw-handlers": "static-1.8856",
  "customer-data-tracking": "static-1.6707",
  "conditional-properties-service-client": "static-1.3648",
  "crm-pipelines-api-client-types": "static-1.3990",
  "multi-currency-client-types": "static-1.3541",
  "external-options-client-types": "static-1.4009",
  "react-dnd-compat": "static-1.4446",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5184",
  "growth-onboarding-confetti": "static-1.2898",
  "growth-onboarding-next-action-utils": "static-1.1349",
  "onboarding-tours-utils": "static-1.366",
  "ui-shepherd-tracker": "static-1.7353",
  "academy-service-client": "static-1.3505",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28002",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8210",
  "video-components-external": "static-1.10633",
  "video-data-lib": "static-1.34291",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8393",
  "payment-link-components": "static-1.23002",
  "ui-addon-emoji-picker": "static-1.9713",
  "EmailSignatureEditor": "static-1.23961",
  "viral-links-lib": "static-1.6862",
  "data-token-picker": "static-1.16085",
  "FileManagerLib": "static-1.38610",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5070",
  "getting-started-shared-tasks-store": "static-1.17064",
  "campaign-roi-lib": "static-1.8343",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.218",
  "eligibility-engine-service-types": "static-1.3011",
  "crm_data": "static-4.91295",
  "crm-links": "static-1.6092",
  "customer-data-sidebar": "static-2.45478",
  "enrichment-properties-lib": "static-1.15128",
  "commerce-billing-lib": "static-1.18560",
  "commerce-shared-components-lib": "static-1.18007",
  "commerce-tools-ui-lib": "static-1.9853",
  "crm-fe-perf": "static-1.22731",
  "calling-global-api": "static-1.63753",
  "calling-internal-common": "static-1.31120",
  "calling-lifecycle-internal": "static-1.65135",
  "calling-lifecycle-messages": "static-1.57429",
  "commerce-products-lib": "static-1.8924",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.505",
  "inbounddb-objects-service-types": "static-1.4072",
  "meetings-icalendar-utils-lib": "static-1.458",
  "object-builder-ui-client": "static-1.48067",
  "pipeline-validation-client-types": "static-1.3813",
  "property-value-citations": "static-1.1472",
  "pulse": "static-1.341",
  "smart-property-lib": "static-1.6010",
  "tiered-pricing": "static-1.864",
  "ui-addon-form-validation": "static-1.10820",
  "growth-onboarding-next-action-components": "static-1.1377",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6408",
  "content-media-composition-data-lib": "static-1.11538",
  "content-media-compositions": "static-2.15545",
  "media-bridge-lib": "static-1.18608",
  "commerce-tours-lib": "static-1.5755",
  "growth-onboarding-reliability": "static-1.4912",
  "sales-checkout-service-client": "static-1.3493",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21350",
  "sales-email-signature-service-client": "static-1.3669",
  "audio-components": "static-1.5648",
  "FileManagerCore": "static-1.38469",
  "FileManagerImages": "static-1.36121",
  "video-components": "static-1.12636",
  "crm_universal": "static-1.21703",
  "customer-data-email": "static-1.17713",
  "calling-error-reporting": "static-1.31126",
  "card-payment-highlight-lib": "static-1.36560",
  "card-subscription-highlight-lib": "static-1.38927",
  "commerce-contract-lib": "static-1.11272",
  "customer-data-content": "static-1.26917",
  "invoices-highlight-card-lib": "static-1.54100",
  "orders-highlight-card-lib": "static-1.20925",
  "products-highlight-card-lib": "static-1.17208",
  "project-storage": "static-1.4559",
  "quotes-highlight-card-lib": "static-1.71284",
  "breeze-intelligence-kit": "static-1.5358",
  "crm-source-interpretation-lib": "static-1.5155",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9612",
  "policy-lib": "static-1.6607",
  "utility-belt": "static-1.2366",
  "customer-data-associations": "static-1.7165",
  "framework-data-table": "static-2.11468",
  "payments-enrollment-embed-lib": "static-1.22084",
  "customer-data-rte": "static-1.32500",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5402",
  "InboxConnectUtils": "static-4.14283",
  "payments-post-enroll-local-storage-lib": "static-1.4939",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37373",
  "shared-worker-versioning": "static-1.10864",
  "calling-usage-tracker": "static-1.6366",
  "voice-sms-access-library": "static-1.309",
  "commerce-permissions": "static-1.585",
  "products-iframe-lib": "static-1.7389",
  "products-ui-components-shared-msw-handlers": "static-1.9911",
  "directed-graph": "static-1.765",
  "event-emitter": "static-1.773",
  "react-tinymce": "static-1.54682",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9675",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53808",
  "tinymce-plugins": "static-1.56922",
  "tinymce-themes": "static-1.55778",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4357",
  "video-embed": "static-1.35125",
  "social-insights-client-types": "static-1.21424",
  "sequences-lib": "static-1.7726",
  "ui-gdpr-components": "static-1.10173",
  "products-ui-components": "static-1.39443",
  "quotes-ui-lib": "static-1.80004",
  "SalesContentIndexUI": "static-3.8937",
  "accounting-integrations-ui-components": "static-1.6763",
  "invoices-ui-lib": "static-1.54116",
  "commerce-products-api": "static-1.1990",
  "SafeStorage": "static-1.4229",
  "invoices-iframe-lib": "static-1.56174",
  "quotes-modal-lib": "static-1.101961",
  "deal-intel-decorators": "static-1.1331",
  "tanstack-virtual": "static-1.26",
  "stripe-embedded-components": "static-1.7176",
  "draft-content-plugins": "static-1.27768",
  "hub-http-contrib": "static-1.2868",
  "ui-addon-sales-email": "static-1.5039",
  "calling-orchestration-schema": "static-1.35086",
  "sales-views-client-types": "static-1.4112",
  "interframe": "static-3.4614",
  "tinymce-data": "static-1.39893",
  "layout-dnd-components": "static-1.12083",
  "layout-dnd-utils": "static-1.11058",
  "ui-brand-identity-lib": "static-1.14025",
  "NamespacedHubStyle": "static-2.8921",
  "outpost": "static-1.4029",
  "sequences-client-types-lib": "static-1.7583",
  "commerce-tax-lib": "static-1.342",
  "property-description-translator": "static-1.3682",
  "FireAlarmUi": "static-1.4356",
  "sales-templates-service-types-lib": "static-1.4016",
  "commerce-analytics-service-client": "static-1.3481",
  "totals-ui-components": "static-1.23055",
  "deal-intel-utils": "static-1.1335",
  "stripe-connect-js": "static-1.65",
  "ContentData": "static-1.67763",
  "layout-data-lib": "static-1.9383",
  "commerce-totals-service-types": "static-1.3664",
  "advanced-menus-core": "static-1.14853",
  "advanced-menus-lib": "static-1.11824",
  "ui-memberships-settings-lib": "static-1.33505",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14852",
  "simple-menus-lib": "static-1.16369"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11626",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.449",
  "dashboard-client-types": "/dashboard-client-types/static-1.247",
  "data-fetching-client": "/data-fetching-client/static-1.9502",
  "foundations-components": "/foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.8",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-jhardy-popover-allow-cross-axis-shift.8",
  "foundations-theming": "/foundations-theming/static-1.4238",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7832",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9529",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11259",
  "I18n": "/I18n/static-7.1577",
  "jasmine-runner": "/jasmine-runner/static-1.6297",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11686",
  "quartz": "/quartz/static-1.6768",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16477",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2688",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8553",
  "settings-ui-lib": "/settings-ui-lib/static-1.12348",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6779",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10969",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9371",
  "unified-auth": "/unified-auth/static-1.248",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.529",
  "usage-tracker": "/usage-tracker/static-1.7161",
  "usage-tracker-core": "/usage-tracker-core/static-1.7011",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7905",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6045",
  "integrations-lib": "/integrations-lib/static-1.15495",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19012",
  "property-management-iframe": "/property-management-iframe/static-1.12425",
  "quartz-config": "/quartz-config/static-1.546",
  "quartz-core": "/quartz-core/static-1.5987",
  "quartz-routing": "/quartz-routing/static-1.198",
  "quick-fetch": "/quick-fetch/static-1.3761",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4460",
  "ts-schema": "/ts-schema/static-1.3929",
  "ui-universal-auth": "/ui-universal-auth/static-1.8734",
  "UIComponents": "/UIComponents/static-3.8206",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3253",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3045",
  "quartz-webpack": "/quartz-webpack/static-1.2992",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.8",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4662",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1954",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9252",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5199",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1287",
  "ui-fonts": "/ui-fonts/static-1.521",
  "ui-images": "/ui-images/static-2.1101",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2721",
  "foundations-theming-base": "/foundations-theming-base/static-1.3223",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.715",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2943",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4152",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8413",
  "ai-rendering-library": "/ai-rendering-library/static-1.9371",
  "chirp-fetch": "/chirp-fetch/static-1.1708",
  "connections-embed-lib": "/connections-embed-lib/static-1.671",
  "copilot-toolkit": "/copilot-toolkit/static-1.10593",
  "laboratory-lib": "/laboratory-lib/static-3.6985",
  "marketplace-embed": "/marketplace-embed/static-1.21534",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8908",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18968",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13183",
  "sanitize-text": "/sanitize-text/static-1.7970",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8522",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5575",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4847",
  "wootric-nps": "/wootric-nps/static-1.6810",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4477",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3980",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66620",
  "cssUtils": "/cssUtils/static-1.741",
  "flux-actions": "/flux-actions/static-1.310",
  "HubStyle": "/HubStyle/static-2.11567",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10036",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10198",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7151",
  "icons": "/icons/static-2.623",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17545",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4346",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-jhardy-popover-allow-cross-axis-shift.8",
  "quartz-i18n": "/quartz-i18n/static-1.443",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3557",
  "customer-data-objects": "/customer-data-objects/static-1.7474",
  "property-translator": "/property-translator/static-1.5236",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7750",
  "hs-promise-utils": "/hs-promise-utils/static-1.5419",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4706",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12910",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5414",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7614",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4300",
  "superstore": "/superstore/static-1.4596",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9972",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7535",
  "hub-http-janus": "/hub-http-janus/static-1.800",
  "hubspotter-http": "/hubspotter-http/static-1.4502",
  "immutable-less": "/immutable-less/static-1.4480",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16419",
  "nav-meta": "/nav-meta/static-1.28982",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10065",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17693",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3699",
  "property-management-common": "/property-management-common/static-1.4712",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8872",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.488",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.443",
  "quartz-head": "/quartz-head/static-1.433",
  "quartz-test": "/quartz-test/static-1.443",
  "quartz-tracking": "/quartz-tracking/static-1.147",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2970",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20426",
  "ContentUtils": "/ContentUtils/static-1.67688",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2314",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38983",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12834",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12972",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13625",
  "ExportDialog": "/ExportDialog/static-6.10212",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40714",
  "reporting-snowflake": "/reporting-snowflake/static-1.55238",
  "reporting-ui-components": "/reporting-ui-components/static-2.63891",
  "reporting-visualizations": "/reporting-visualizations/static-1.58696",
  "ui-addon-teams": "/ui-addon-teams/static-1.21274",
  "magpie-lib": "/magpie-lib/static-1.5420",
  "magpie-types": "/magpie-types/static-1.4880",
  "simple-logging-lib": "/simple-logging-lib/static-1.2876",
  "navigation-components": "/navigation-components/static-1.17345",
  "ai-studio-lib": "/ai-studio-lib/static-1.11060",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10316",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7816",
  "ui-tool-access": "/ui-tool-access/static-1.9971",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8071",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5578",
  "usage-tracker-public": "/usage-tracker-public/static-1.6972",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3445",
  "persist-promise": "/persist-promise/static-1.3533",
  "reference-resolvers": "/reference-resolvers/static-1.7987",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3769",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.165",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2825",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2245",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "atom": "/atom/static-1.4895",
  "purchase-motions-components": "/purchase-motions-components/static-1.5515",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1376",
  "crm-component-utils": "/crm-component-utils/static-1.38528",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5697",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6698",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7920",
  "navigation-messaging": "/navigation-messaging/static-1.6672",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9527",
  "cms-field-types": "/cms-field-types/static-1.4632",
  "content-icons-ui": "/content-icons-ui/static-1.2164",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7074",
  "crm-message-bus": "/crm-message-bus/static-1.42429",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21418",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9649",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4553",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3858",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6603",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.799",
  "onboarding-tours": "/onboarding-tours/static-1.16300",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13124",
  "academy-common-lib": "/academy-common-lib/static-1.13085",
  "content-assistance-lib": "/content-assistance-lib/static-1.7485",
  "dashboard-lib": "/dashboard-lib/static-1.80718",
  "file-manager-components": "/file-manager-components/static-1.22970",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17946",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17665",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17657",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19514",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8519",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4591",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10742",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8855",
  "user-context": "/user-context/static-1.4925",
  "growth-payments-core": "/growth-payments-core/static-1.24788",
  "reporting-plugins": "/reporting-plugins/static-1.10017",
  "reporting-reports": "/reporting-reports/static-1.66298",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.550",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28905",
  "react-codemirror": "/react-codemirror/static-1.10452",
  "apps-service-types": "/apps-service-types/static-1.3703",
  "oauth-service-types": "/oauth-service-types/static-1.4072",
  "onboarding-scopes": "/onboarding-scopes/static-1.6288",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4514",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7516",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14614",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3468",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8631",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2183",
  "purchase-motions-api": "/purchase-motions-api/static-1.5518",
  "signup-constants": "/signup-constants/static-1.18469",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "card-properties-lib": "/card-properties-lib/static-1.43586",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36504",
  "crm-actions": "/crm-actions/static-1.6131",
  "crm-cards-data": "/crm-cards-data/static-1.1261",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42986",
  "customer-data-properties": "/customer-data-properties/static-1.50858",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8856",
  "customer-data-tracking": "/customer-data-tracking/static-1.6707",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3648",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3990",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3541",
  "external-options-client-types": "/external-options-client-types/static-1.4009",
  "react-dnd-compat": "/react-dnd-compat/static-1.4446",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5184",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2898",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1349",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.366",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7353",
  "academy-service-client": "/academy-service-client/static-1.3505",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28002",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8210",
  "video-components-external": "/video-components-external/static-1.10633",
  "video-data-lib": "/video-data-lib/static-1.34291",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8393",
  "payment-link-components": "/payment-link-components/static-1.23002",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9713",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23961",
  "viral-links-lib": "/viral-links-lib/static-1.6862",
  "data-token-picker": "/data-token-picker/static-1.16085",
  "FileManagerLib": "/FileManagerLib/static-1.38610",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5070",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17064",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8343",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.218",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "crm_data": "/crm_data/static-4.91295",
  "crm-links": "/crm-links/static-1.6092",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45478",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15128",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18560",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18007",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9853",
  "crm-fe-perf": "/crm-fe-perf/static-1.22731",
  "calling-global-api": "/calling-global-api/static-1.63753",
  "calling-internal-common": "/calling-internal-common/static-1.31120",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65135",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57429",
  "commerce-products-lib": "/commerce-products-lib/static-1.8924",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.505",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4072",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.458",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48067",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3813",
  "property-value-citations": "/property-value-citations/static-1.1472",
  "pulse": "/pulse/static-1.341",
  "smart-property-lib": "/smart-property-lib/static-1.6010",
  "tiered-pricing": "/tiered-pricing/static-1.864",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10820",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1377",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6408",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11538",
  "content-media-compositions": "/content-media-compositions/static-2.15545",
  "media-bridge-lib": "/media-bridge-lib/static-1.18608",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5755",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4912",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3493",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21350",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3669",
  "audio-components": "/audio-components/static-1.5648",
  "FileManagerCore": "/FileManagerCore/static-1.38469",
  "FileManagerImages": "/FileManagerImages/static-1.36121",
  "video-components": "/video-components/static-1.12636",
  "crm_universal": "/crm_universal/static-1.21703",
  "customer-data-email": "/customer-data-email/static-1.17713",
  "calling-error-reporting": "/calling-error-reporting/static-1.31126",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36560",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38927",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11272",
  "customer-data-content": "/customer-data-content/static-1.26917",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54100",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20925",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17208",
  "project-storage": "/project-storage/static-1.4559",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71284",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5358",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5155",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9612",
  "policy-lib": "/policy-lib/static-1.6607",
  "utility-belt": "/utility-belt/static-1.2366",
  "customer-data-associations": "/customer-data-associations/static-1.7165",
  "framework-data-table": "/framework-data-table/static-2.11468",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22084",
  "customer-data-rte": "/customer-data-rte/static-1.32500",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5402",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14283",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4939",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37373",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10864",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6366",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.309",
  "commerce-permissions": "/commerce-permissions/static-1.585",
  "products-iframe-lib": "/products-iframe-lib/static-1.7389",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9911",
  "directed-graph": "/directed-graph/static-1.765",
  "event-emitter": "/event-emitter/static-1.773",
  "react-tinymce": "/react-tinymce/static-1.54682",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9675",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53808",
  "tinymce-plugins": "/tinymce-plugins/static-1.56922",
  "tinymce-themes": "/tinymce-themes/static-1.55778",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4357",
  "video-embed": "/video-embed/static-1.35125",
  "social-insights-client-types": "/social-insights-client-types/static-1.21424",
  "sequences-lib": "/sequences-lib/static-1.7726",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10173",
  "products-ui-components": "/products-ui-components/static-1.39443",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80004",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8937",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6763",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54116",
  "commerce-products-api": "/commerce-products-api/static-1.1990",
  "SafeStorage": "/SafeStorage/static-1.4229",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56174",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101961",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1331",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7176",
  "draft-content-plugins": "/draft-content-plugins/static-1.27768",
  "hub-http-contrib": "/hub-http-contrib/static-1.2868",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5039",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35086",
  "sales-views-client-types": "/sales-views-client-types/static-1.4112",
  "interframe": "/interframe/static-3.4614",
  "tinymce-data": "/tinymce-data/static-1.39893",
  "layout-dnd-components": "/layout-dnd-components/static-1.12083",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11058",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14025",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8921",
  "outpost": "/outpost/static-1.4029",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7583",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.342",
  "property-description-translator": "/property-description-translator/static-1.3682",
  "FireAlarmUi": "/FireAlarmUi/static-1.4356",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4016",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3481",
  "totals-ui-components": "/totals-ui-components/static-1.23055",
  "deal-intel-utils": "/deal-intel-utils/static-1.1335",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "ContentData": "/ContentData/static-1.67763",
  "layout-data-lib": "/layout-data-lib/static-1.9383",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3664",
  "advanced-menus-core": "/advanced-menus-core/static-1.14853",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11824",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33505",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14852",
  "simple-menus-lib": "/simple-menus-lib/static-1.16369"
}
};
